import { ASTROORCA_CONTEXT } from '@/constants/context';
import { VIDEO_URLS } from '@/constants/videos';
import React from 'react';

const AstroOrca = () => {
  return (
    <div
      id='content-AstroOrca'
      className='w-full h-full flex flex-col box-border gap-4 xl:gap-6 relative'
    >
      {/* Desktop Image */}
      <img
        src={VIDEO_URLS.ASTRO_ORCA}
        alt='AstroOrca'
        className='hidden xl:block absolute left-[65%] bottom-[5%] translate-x-0 translate-y-0 w-80 h-80 object-cover pointer-events-none z-20 rounded-full'
      />

      <div className='flex flex-col gap-4 md:gap-6 relative z-20 xl:w-[600px] xl:h-[400px] md:h-[350px] h-[642px]'>
        <div className='w-full flex flex-col justify-start px-4 md:px-0'>
          <h1 className='leading-7 md:leading-8 text-4xl md:text-4xl font-bold text-white text-left'>
            <strong>
              Astro-<span className='text-[#fccb15]'>O</span>rca
            </strong>
          </h1>
        </div>
        <div className='border-l-4 border-[#FCCB16] md:pl-3 ml-4 md:ml-0'>
          <div className='text-base md:text-xl font-semibold text-white px-4 md:px-0'>
            {ASTROORCA_CONTEXT.SUBTITLE}
          </div>
        </div>
        <div className='w-full flex justify-start items-start px-4 md:px-0'>
          <section className='w-full flex justify-start'>
            <div className='text-sm md:text-lg font-medium text-white md:text-justify xl:hidden'>
              {ASTROORCA_CONTEXT.DESCRIPTION}
            </div>
            <div className='hidden xl:block text-lg font-medium text-white'>
              {ASTROORCA_CONTEXT.DESCRIPTION.split('spacecrafts.').map((part, index) => (
                <p key={index}>
                  {index === 0 ? part + 'spacecrafts.' : part.trim()}
                </p>
              ))}
            </div>
          </section>
        </div>
        <div className='md:hidden relative w-[calc(100%+2rem)] h-[319px] overflow-hidden rounded-lg -mx-4'>
        <img
          src={VIDEO_URLS.ASTRO_ORCA}
          alt='AstroOrca'
          className='w-48 h-48 md:w-[300px] md:h-[300px] left-[25%] top-[10%] object-cover pointer-events-none rounded-full absolute'
        />
        </div>
      </div>

      {/* Mobile & Tablet Image */}
      <div className='xl:hidden hidden relative w-full h-[350px] overflow-hidden mt-8 rounded-lg md:flex items-center justify-center md:h-[350px]'>
        <img
          src={VIDEO_URLS.ASTRO_ORCA}
          alt='AstroOrca'
          className='w-48 h-48 md:w-[300px] md:h-[300px] object-cover pointer-events-none rounded-full'
        />
      </div>
    </div>
  );
};

export default React.memo(AstroOrca);
